export default __webpack_public_path__ + "static/media/BannerChart2.a5e6552f.jpg";